function importAll(r) {
    return r.keys().map((filePath) => {
        const fileName = filePath.replace('./', '').replace('.svg', '');
        const module = r(filePath);

        return {
            key: fileName,
            label: fileName,
            url: module.default || module,
            module,
        };
    });
}

const DynamicLoader = importAll(require.context('./icons', false, /\.svg$/));

export default DynamicLoader;
